import { createFileRoute } from '@tanstack/react-router';

import { AnnouncementList } from '@/components/company/announcement/announcement-list';

export const Route = createFileRoute('/(app)/company/announce')({
  component: AnnouncementRoute,
});

function AnnouncementRoute() {
  return <AnnouncementList />;
}
